import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { catchError, Observable, tap, throwError } from "rxjs";
import { PermissionService } from "../services/permission.service";
import { Router } from "@angular/router";

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
    
    constructor(private permissionService: PermissionService, private router: Router) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            tap( (event: HttpEvent<any>) => {
                if(event instanceof HttpResponse) {
                    // console.log("HttpAuthInterceptor - Response received with status: " + event.status);
                    // console.log("HttpAuthInterceptor - Response received: ", event);
                }
            }),
            // tap( (event: HttpEvent<any>) => {
            //     if(event instanceof HttpResponse) {
            //         console.log("HttpAuthInterceptor - Response received with status: " + event.status);
            //         console.log("HttpAuthInterceptor - Response received: ", event);
            //         // const authHeader = event.headers.get('Authorization');
            //         const userAuthenticated = this.permissionService.isUserAuthenticated();
            //         if(!userAuthenticated) {
            //             console.log("HttpAuthInterceptor - user not authenticated correctly... let's clean the session!");
            //             this.permissionService.checkUserAuthentication();
            //             this.router.navigateByUrl('/');
            //         }
            //     }
            // }),
            catchError((error: any) => {
                console.log("HttpAuthInterceptor - Error response received with status: " + error.status);
                console.log("HttpAuthInterceptor - Error response received: " + error.message);
                console.log("HttpAuthInterceptor - Error response received in JSON: " + JSON.stringify(error));
                if (error.status === 403 || error.status === 401) {
                    const userAuthenticated: boolean = this.permissionService.isUserAuthenticated();
                    if (!userAuthenticated) {
                        console.log("HttpAuthInterceptor - user not authenticated correctly... let's clean the session!");
                        this.permissionService.signout();
                    }
                    this.permissionService.alert("Attenzione: il tuo utente non è autorizzato ad accedere alle funzionalità e/o ai dati selezionati. Verifica con l'amministratore di sistema.\n\n(Errore: " + error.message + " - Codice: " + error.status + ")");
                }
                if(error.status === 401) {
                    console.log("HttpAuthInterceptor - Navigating to login page due to 401 Unauthorized error.");
                    this.permissionService.signout();
                    this.router.navigateByUrl('/login');
                }
                return throwError(() => (error as any));
            }),
        );
    }
}